// document.addEventListener('DOMContentLoaded', function () {
//   const accordionTriggers = document.querySelectorAll('.accordion-trigger');

//   accordionTriggers.forEach((trigger) => {
//     trigger.addEventListener('click', function () {
//       const content = document.getElementById(this.getAttribute('aria-controls'));
//       const isExpanded = this.getAttribute('aria-expanded') === 'true';

//       // Toggle states
//       this.setAttribute('aria-expanded', !isExpanded);
//       content.setAttribute('aria-hidden', isExpanded);

//       // Animate height
//       if (!isExpanded) {
//         // Opening
//         content.style.height = content.scrollHeight + 'px';
//       } else {
//         // Closing
//         content.style.height = content.scrollHeight + 'px';
//         // Force a reflow
//         content.offsetHeight;
//         content.style.height = '0px';
//       }
//     });
//   });

//   // Handle transition end
//   document.querySelectorAll('.accordion-content').forEach((content) => {
//     content.addEventListener('transitionend', function () {
//       if (this.getAttribute('aria-hidden') === 'true') {
//         this.style.height = '0px';
//       } else {
//         this.style.height = 'auto';
//       }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.accordion-trigger');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const content = document.getElementById(
        this.getAttribute('aria-controls')
      );

      const isOpen = this.getAttribute('aria-expanded') === 'true';

      // Close others (optional)
      document.querySelectorAll('.accordion-trigger').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('.accordion-content').forEach((el) => {
        if (el !== content) collapse(el);
      });

      if (!isOpen) {
        this.setAttribute('aria-expanded', 'true');
        expand(content);
      } else {
        collapse(content);
      }
    });
  });

  function expand(el) {
    el.style.display = 'block';

    const height = el.scrollHeight + 'px';
    el.style.height = '0px';

    requestAnimationFrame(() => {
      el.style.height = height;
    });

    el.setAttribute('aria-hidden', 'false');

    el.addEventListener(
      'transitionend',
      () => {
        el.style.height = 'auto'; // reset after animation
      },
      { once: true }
    );
  }

  function collapse(el) {
    const height = el.scrollHeight + 'px';
    el.style.height = height;

    requestAnimationFrame(() => {
      el.style.height = '0px';
    });

    el.setAttribute('aria-hidden', 'true');
  }
});